import { render, staticRenderFns } from "./Modal-others-products.vue?vue&type=template&id=08a4ea75&scoped=true&lang=pug"
import script from "./Modal-others-products.vue?vue&type=script&lang=js"
export * from "./Modal-others-products.vue?vue&type=script&lang=js"
import style0 from "./Modal-others-products.vue?vue&type=style&index=0&id=08a4ea75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a4ea75",
  null
  
)

export default component.exports